import './collection-slider.scss';

if (!window.dAgency) window.dAgency = {};
window.dAgency.initCollectionSlider = (context) => {
  const sectionContainer = context.classList.contains('.shopify-section')
    ? context
    : context.closest('.shopify-section');
  if (!sectionContainer) return;

  const sliderContainer = sectionContainer.querySelector('.swiper');
  if (!sliderContainer) return;

  const sliderNumber = sliderContainer.dataset.slideNumber;

  switch (sliderNumber){
    case 'M':
      var sliderNumber360 = 1.6;
      var sliderNumber768 = 3;
      var sliderNumber1920 = 4.1;
      break
    case 'S':
      var sliderNumber360 = 1.6;
      var sliderNumber768 = 3;
      var sliderNumber1920 = 3.1;
      break
    default:
      var sliderNumber360 = 2.4;
      var sliderNumber768 = 3.7;
      var sliderNumber1920 = 5.1;
  }

  const swiper = new Swiper(sliderContainer, {
    slidesPerView: sliderNumber360,
    breakpoints: {
      450: {
        slidesPerView: sliderNumber768
      },
      768: {
        slidesPerView: sliderNumber1920
      }
    },
    navigation: {
      nextEl: sectionContainer.querySelector('.swiper-button-next'),
      prevEl: sectionContainer.querySelector('.swiper-button-prev'),
    },
    scrollbar: {
      el: sectionContainer.querySelector('.swiper-scrollbar'),
      draggable: true
    }
  });
};

if (document.readyState != 'loading') {
  [].forEach.call(document.querySelectorAll('.collection-slider__section'), (el) => {
    window.dAgency.initCollectionSlider(el);
  });
} else {
  document.addEventListener('DOMContentLoaded', () => {
    [].forEach.call(document.querySelectorAll('.collection-slider__section'), (el) => {
      window.dAgency.initCollectionSlider(el);
    });
  });
}
